import { css } from 'styled-components'

type CustomAlignProps = {
  left?: boolean
  center?: boolean
  right?: boolean
}

const leftCss = ({ left }: CustomAlignProps) =>
  left &&
  css`
    text-align: left;
  `

const centerCss = ({ center }: CustomAlignProps) =>
  center &&
  css`
    text-align: center;
  `

const rightCss = ({ right }: CustomAlignProps) =>
  right &&
  css`
    text-align: right;
  `

export type { CustomAlignProps }
export { centerCss, leftCss, rightCss }
